import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HomeWrapper = styled.div`
  padding: 1em 1.5em;
`;

const Home = props => (
  <HomeWrapper>
    <h1>Welcome, Demuxed Selection Committee</h1>

    {props.user
      ? <Link to="/review">Review</Link>
      : <Link to="/login">Login</Link>}
  </HomeWrapper>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.jsx